var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "unitary_form" },
    [
      _c("v-autocomplete", {
        staticClass: "grv-input",
        attrs: {
          dense: "",
          items: _vm.legacy_contracts,
          "item-value": "id",
          "item-text": "name",
          name: "Contrat",
          loading: _vm.loading_contracts,
          rules: [_vm.checkRequired],
          "menu-props": { contentClass: "grv-menu" }
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          change: function($event) {
            return _vm.get_contract_assets($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.contractid_param } })]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.form.parameters.legacy_contract_id,
          callback: function($$v) {
            _vm.$set(_vm.form.parameters, "legacy_contract_id", $$v)
          },
          expression: "form.parameters.legacy_contract_id"
        }
      }),
      _vm._v(" "),
      _c("Hint", {
        attrs: { param: _vm.contractid_param, errored: _vm.errored }
      }),
      _vm._v(" "),
      _c("AssetIdsField", {
        attrs: {
          dense: false,
          readonly: false,
          loading: _vm.loading_contract_assets,
          behive_category: "legacy",
          param: _vm.assetids_param,
          babel_id: _vm.babel_id,
          value: _vm.form.parameters.asset_ids
        },
        on: {
          "update:value": function($event) {
            return _vm.$set(_vm.form.parameters, "asset_ids", $event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "subheading",
          class: { "error--text": _vm.form.parameters.asset_ids.length === 0 }
        },
        [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.form.parameters.asset_ids.length) + "\n\t\t"
          ),
          _vm.form.parameters.asset_ids.length > 1
            ? _c("span", [_vm._v("\n\t\t\tAsset(s) sélectionné(s)\n\t\t")])
            : _c("span", [_vm._v("\n\t\t\tAsset sélectionné\n\t\t")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c961004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c961004","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_legacy_archive_contract.vue
// module id = null
// module chunks = 